import { createApp } from 'vue'
import App from './App.vue'

import router from "./router"
import store from "./store";
import VueCookies from 'vue3-cookies';
// import "./assets/css/owl.carousel.min.css";
import "./assets/css/bootstrap.min.css";
// import "./assets/css/bootstrap.min.css.map";
import "./assets/css/style1.css";
import "./assets/css/style.css";
import "./assets/css/responsive.css";
import "./assets/fontawesome/css/all.css";
import "bootstrap";
import 'vue3-carousel/dist/carousel.css';
import "vue-gtranslate/translator.css";
import "vue-awesome-paginate/dist/style.css";
import VueAwesomePaginate from "vue-awesome-paginate";
import './registerServiceWorker'
import globalProperties from './globalServices';
import { apiCall } from './shared/services/apiCall';
import { setHeaders } from './shared/services/headers';
import { errorToast } from './shared/services/helper';



router.beforeEach(async (to, from, next) => {
    const isAuthenticated = store.getters.isAuthenticated;
    if(to.query.auth && !isAuthenticated) {
        await getMultiTemplateAuth(to);
        cookies.set('AUTH_TOKEN', to.query.auth);
        return next({ name: 'Home' })
    }
    const lastLoginAt = store.getters.stateUser?.last_login_at;
    const underMaintenance = store.getters.underMaintenance;
    const isMaintenancePage = to.name === 'Maintenance';
    const modalInstance = document.querySelector('.modal.show')
    if (underMaintenance) {
        if (!isMaintenancePage) next({ name: 'Maintenance' })
        else next();
    } else {
        if (isMaintenancePage) next({ name: 'Home' });
        else{
            if(modalInstance && modalInstance.id != 'success_submit'){
                next(false);
                return;
            }
            if (isAuthenticated && !lastLoginAt && to?.name !== 'change-password') {
                next({ name: 'change-password' });
                return;
            } else if (to?.name == 'change-password' && !isAuthenticated) {
                next({ name: 'Home' })
                return;
            }
            next();
        }
    }
});

window.addEventListener('popstate', (event) => {
    if(document.querySelector('.modal.show')) {
        window.location.reload();
    }
});

async function initApp() {
    const app = createApp(App);
    app.use(globalProperties);
    app.use(store);
    app.use(router);
    app.use(VueCookies);
    app.use(VueAwesomePaginate);
    await router.isReady(); 
    app.mount("#app");
};

initApp();

const setUserDataToStore = async (userData) => {
        let user = {
            notificationSubscribed: null,
            notificationUnsubscribed: null,
            isDemo: userData?.demo || false
        }
        store.dispatch('setUser', {...userData?.user, ...user});
        store.dispatch('setChips', userData?.user?.chips);
        store.dispatch('setEventManage', userData?.event_manage);
  };
 
const getMultiTemplateAuth = async(routeData) => {
    try{
        window.authorization_token = `Bearer ${routeData.query.auth}`;
        store.dispatch('setToken', `Bearer ${routeData.query.auth}`);
        setHeaders();
        let response = await apiCall('get', 'GET_USER_INFO');
        if (response && response.status == 200) {
            if (response?.data?.status == 0 || response?.data?.error || response?.data?.msg) {
                errorToast(response?.data?.error);
            } else {
                setUserDataToStore(response.data);
                location.reload();
                store.state.auth.user.token = routeData.query.auth;
            }
        }
        return
    }
    catch(error){
        console.log(error);
        errorToast(error || 'Something went wrong')
    }
  }
